import clickoutside from "./clickoutside";
import inputNumber from './inputNumber'


const directives = {
    clickoutside,inputNumber
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
